"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcPosition = void 0;
const Tooltip_1 = require("../atoms/Tooltip");
const rectCenter_1 = require("./rectCenter");
const INDENT = 5;
function calcPosition(positionValue, selfOuterSize, targetRect) {
    const newPosition = { top: 0, left: 0 };
    const maxTop = window.innerHeight - selfOuterSize.height;
    const maxLeft = window.innerWidth - selfOuterSize.width;
    switch (positionValue) {
        case Tooltip_1.TooltipPosition.Top:
            newPosition.top = targetRect.top - selfOuterSize.height - INDENT;
            break;
        case Tooltip_1.TooltipPosition.Right:
            newPosition.left = targetRect.left + targetRect.width + INDENT;
            break;
        case Tooltip_1.TooltipPosition.Bottom:
            newPosition.top = targetRect.top + targetRect.height + INDENT;
            break;
        case Tooltip_1.TooltipPosition.Left:
            newPosition.left = Math.max(0, targetRect.left - selfOuterSize.width - INDENT);
            break;
    }
    const targetCenter = (0, rectCenter_1.getRectCenter)(targetRect);
    switch (positionValue) {
        case Tooltip_1.TooltipPosition.Top:
        case Tooltip_1.TooltipPosition.Bottom:
            newPosition.left = targetCenter.left - selfOuterSize.width / 2;
            newPosition.left = Math.max(0, Math.min(maxLeft, newPosition.left));
            break;
        case Tooltip_1.TooltipPosition.Left:
        case Tooltip_1.TooltipPosition.Right:
            newPosition.top = targetCenter.top - selfOuterSize.height / 2;
            newPosition.top = Math.max(0, Math.min(maxTop, newPosition.top));
            break;
    }
    return newPosition;
}
exports.calcPosition = calcPosition;
